import { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import EpicDetails from "../../containers/EpicDetails";
import EpicsList from "../../containers/EpicsList";
import PageNotFound from "../PageNotFound";
import i18n from "../../lib/i18n";
import Product from "../../models/Product";
import Loader from "../../components/Loader";
import { MdLaunch } from "react-icons/md";

import "./style.scss";

export default function ProductDetails(props) {
  const [productDetails, setProductDetails] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState();

  const epicId = props.match.params.epicId;
  const epicData = productDetails.epics?.find(epic => Number(epic.id) === Number(epicId));

  useEffect(() => {
    setIsLoading(true);
    Product.getProductDetails().then(result => {
      setProductDetails(result);
      setIsLoading(false);
    }).catch(err => {
      setErrorMessage(err);
    });
  }, [setProductDetails]);

  if (epicId && !epicData && !isLoading) {
    return <PageNotFound />
  }

  return (
    <>
      <Sidebar />
      <main className="ProductDetails component-dashboard p-xl">
        {isLoading && (
          <div className="centered h-100pc">
            <Loader />
          </div>
        )}
        {errorMessage && (<div className="centered h-100pc">An unexpected error occurred</div>)}
        {productDetails && !isLoading && (
          <div className="page-clamp">
            <div className="flex-row mobile-flex-column flex-gap-md card">
              <img className="product-image w-240px" src={productDetails?.images?.medium} alt=""></img>
              <div className="flex-column flex-gap-sm p-md p-t-0">
                <h1 className="">{productDetails?.name}</h1>
                <div>
                  <h3>{i18n("products.budget.title")}</h3>
                  <div className="m-t-sm">
                    {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'INR' }).format(productDetails.budget)}
                  </div>
                </div>
              </div>
            </div>
            <div className="card m-t-lg p-md">
              <h2 className="">{i18n("products.market_research.title")}</h2>
              <div className="m-t-sm">
                {((researchLinks) => (
                  researchLinks?.length ? (
                    <div className="flex-column flex-gap-xs">
                      {researchLinks.map((link, index) => (
                        <a className="flex-row flex-align-center flex-gap-sm" key={index} href={link}>{`Link ${index + 1}`} <MdLaunch /></a>
                      ))}
                    </div>
                  ) : i18n("products.market_research_empty")
                ))(productDetails?.marketReasearch?.split(", "))}
              </div>
            </div>
            <div className="release-list">
              { }
            </div>
            <div className="m-t-lg">
              {epicId ? (
                <EpicDetails currentPath={`/product/${props.match.params.productId}`} data={epicData} />
              ) : (
                <EpicsList currentPath={`/product/${props.match.params.productId}`} epics={productDetails.epics}></EpicsList>
              )}
            </div>
          </div>
        )}
      </main>
    </>
  )
}